import { render, staticRenderFns } from "./FontSelect.vue?vue&type=template&id=67dee28a"
import script from "./FontSelect.vue?vue&type=script&lang=js"
export * from "./FontSelect.vue?vue&type=script&lang=js"
import style0 from "./FontSelect.vue?vue&type=style&index=0&id=67dee28a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports